import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { CompanyNote } from "@/types";

/**
 * This hook is used to add a new company note to the company notes query
 * without refetching the entire query.
 */
export const useAddCompanyNote = () => {
  const currentCompanyId = useCurrentCompanyId();
  const queryClient = useQueryClient();

  return ({ companyNoteToAdd }: { companyNoteToAdd: CompanyNote }) => {
    queryClient.setQueryData(
      ["company-notes", currentCompanyId],
      (cachedData: CompanyNote[]) => {
        // Important to add the new company note to the top of the list.
        return [companyNoteToAdd, ...cachedData];
      },
    );
  };
};
